(() => {
  const results = document.querySelector('[data-live-filter-results]');
  const panels = Array.from(document.querySelectorAll('.CollectionFilters')).filter(panel => panel.querySelector('.custom-filters'));
  if (!results || !panels.length) return;
  let controller;
  let version = 0;
  let desiredSort = new URL(location.href).searchParams.get('sort_by');
  let pendingUrl = null;
  let appliedUrl = null;
  const statuses = document.querySelectorAll('[data-live-filter-status]');
  const checkboxes = () => document.querySelectorAll('.CollectionFilters .collection--filter-checkbox');
  const brands = () => document.querySelectorAll('[data-brand-filter] select');
  const sliders = () => document.querySelectorAll('#price-slider');

  function status(kind) {
    statuses.forEach(node => { node.textContent = kind ? node.dataset[kind] : ''; });
    results.setAttribute('aria-busy', kind === 'loading' ? 'true' : 'false');
  }
  function invalidate() {
    version += 1;
    if (controller) controller.abort();
    pendingUrl = null;
  }
  function buildUrl(panel) {
    const current = new URL(location.href);
    const parts = current.pathname.split('/').filter(Boolean);
    const handle = parts[parts.indexOf('collections') + 1];
    const base = handle === 'vendors' || handle === 'types' ? 'all-products' : handle;
    const tags = Array.from(panel.querySelectorAll('.collection--filter-checkbox:checked'), input => input.value);
    const brand = panel.querySelector('[data-brand-filter] select');
    if (brand && brand.value) tags.push(brand.value);
    const url = new URL(current.origin + '/collections/' + base + (tags.length ? '/' + Array.from(new Set(tags)).map(encodeURIComponent).join('+') : ''));
    const slider = panel.querySelector('#price-slider');
    if (slider && Number(slider.dataset.minPrice) > 0) url.searchParams.set('filter.v.price.gte', slider.dataset.minPrice);
    if (slider && Number(slider.dataset.maxPrice) < 26000) url.searchParams.set('filter.v.price.lte', slider.dataset.maxPrice);
    if (desiredSort) url.searchParams.set('sort_by', desiredSort);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    return url;
  }
  function preserveLayout(container) {
    const previous = results.querySelector('.ProductList');
    const next = container.querySelector('.ProductList');
    if (!previous || !next) return;
    for (const type of ['mobile', 'desktop']) {
      const count = previous.getAttribute('data-' + type + '-count');
      if (!count) continue;
      next.setAttribute('data-' + type + '-count', count);
      next.querySelectorAll('.Grid__Cell').forEach(cell => {
        const desktopSuffix = Array.from(cell.classList).some(name => name.endsWith('--lap-and-up')) ? 'lap-and-up' : 'desk';
        Array.from(cell.classList).forEach(name => {
          if (type === 'mobile' ? /^1\/[^ ]+--phone$/.test(name) : /^1\/[^ ]+--(desk|lap-and-up|tablet-and-up)$/.test(name)) cell.classList.remove(name);
        });
        if (type === 'mobile') cell.classList.add('1/' + count + '--phone');
        else {
          cell.classList.add('1/' + count + '--' + desktopSuffix);
          cell.classList.add('1/' + (count === '4' ? '3' : '2') + '--tablet-and-up');
        }
      });
    }
  }
  async function apply(panel = panels[0]) {
    const url = buildUrl(panel);
    if (url.href === pendingUrl || url.href === appliedUrl && !pendingUrl) return;
    invalidate();
    const requestVersion = version;
    controller = new AbortController();
    pendingUrl = url.href;
    status('loading');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const request = new URL(url);
    request.searchParams.set('view', 'ajax');
    try {
      const response = await fetch(request.href, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('Filter request failed');
      const content = await response.text();
      if (requestVersion !== version) return;
      const parsed = new DOMParser().parseFromString(content, 'text/html');
      const section = parsed.querySelector('#shopify-section-collection-template');
      if (!section || !section.querySelector('.ProductListWrapper, .EmptyState')) throw new Error('Missing filter results');
      preserveLayout(section);
      results.innerHTML = section.innerHTML;
      results.querySelectorAll('a[href]').forEach(link => {
        const clean = new URL(link.getAttribute('href'), url);
        clean.searchParams.delete('view');
        link.href = clean.href;
      });
      const oldFaq = document.querySelector('#shopify-section-fpd-faqs-section');
      const newFaq = parsed.querySelector('#shopify-section-fpd-faqs-section');
      if (oldFaq && newFaq) {
        oldFaq.innerHTML = newFaq.innerHTML;
        oldFaq.querySelectorAll('.faq-question').forEach(question => {
          question.addEventListener('click', () => {
            const item = question.closest('.faq-item');
            item.classList.toggle('active');
            question.querySelector('.faq-icon').textContent = item.classList.contains('active') ? '-' : '+';
          });
        });
      }
      history.pushState({ path: url.href, zeppFilters: true }, '', url.href);
      appliedUrl = url.href;
      if (window.lazySizes) window.lazySizes.autoSizer.checkElems();
      results.dispatchEvent(new CustomEvent('zepp:filters-rendered', { bubbles: true }));
      status(null);
    } catch (error) {
      if (requestVersion === version && error.name !== 'AbortError') status('error');
    } finally {
      if (requestVersion === version) {
        pendingUrl = null;
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }
    }
  }
  checkboxes().forEach(input => input.addEventListener('change', () => {
    checkboxes().forEach(other => { if (other.value === input.value) other.checked = input.checked; });
    apply(input.closest('.CollectionFilters'));
  }));
  brands().forEach(select => select.addEventListener('change', () => {
    brands().forEach(other => { other.value = select.value; });
    apply(select.closest('.CollectionFilters'));
  }));
  function clear() {
    document.dispatchEvent(new CustomEvent('zepp:cancel-price-input'));
    checkboxes().forEach(input => { input.checked = false; });
    brands().forEach(select => { select.value = ''; });
    sliders().forEach(slider => { if (slider.noUiSlider) slider.noUiSlider.set([0, 26000]); });
    apply();
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('#ClearFilters, [data-live-filter-results] [data-action="reset-tags"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    clear();
  }, true);
  document.addEventListener('zepp:price-change', event => apply(event.detail.source.closest('.CollectionFilters')));
  document.addEventListener('zepp:price-pending', () => {
    invalidate();
    status(null);
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
  history.replaceState(Object.assign({}, history.state, { path: location.href }), '', location.href);
  window.addEventListener('popstate', () => location.reload());
  window.ZeppLiveFilters = { sort(value) { desiredSort = value; apply(); } };
})();